// extracted by mini-css-extract-plugin
export default {"container":"MerchSuccess_container__BM3VB","h1":"MerchSuccess_h1__uXy0j","imageBox":"MerchSuccess_imageBox__5989g","thankYouNote":"MerchSuccess_thankYouNote__3NCqb"};